export default {
    searchFriend(state) {
        return state.searchFriend;
    }
}